import { IRoute } from "@src/routes";
import ListUsersPage from "./pages/ListUsersPage";
import EditUserPage from "./pages/EditUserPage";
import ViewUserPage from "./pages/ViewUserPage";

import { SsoRolesEnum } from "@funcional/react-auth-ui";

const routes: IRoute[] = [
  {
    path: "/sso/users/:uuid/edit",
    key: "SSO_USER_EDIT",
    exact: true,
    roles: [SsoRolesEnum.MASTER],
    component: EditUserPage,
  },
  {
    menu: { label: "Usuário" },
    path: "/sso/users/:uuid",
    key: "SSO_USER_VIEW",
    exact: true,
    roles: [SsoRolesEnum.MASTER],
    component: ViewUserPage,
  },
  {
    menu: { label: "Usuários" },
    path: "/sso/users",
    key: "SSO_USER_LIST",
    exact: true,
    roles: [SsoRolesEnum.MASTER],
    component: ListUsersPage,
  },
];

export default routes;
